import { Table, TableHeader, TableProvider, useTableState } from '@optimus-web/core';
import { CashierPastShift, useRepositoryQuery } from '@mews-commander/data-access';
import { lt } from '@mews/framework';
import { useColumns } from './hooks/useColumns';
import { useDateFilter } from './hooks/useDateFilter';

interface Props {
    cashierId: string;
}

export const PastShiftsTable = ({ cashierId }: Props) => {
    const [tableState, setTableState] = useTableState<CashierPastShift>({
        pagination: {
            show: true,
        },
    });

    const columns = useColumns(cashierId);
    const { filterComponent, dateRangeDates } = useDateFilter();

    const { data, isLoading } = useRepositoryQuery('cashiers', 'getClosedShifts', {
        cashierId,
        startUtc: dateRangeDates.startDate,
        endUtc: dateRangeDates.endDate,
        pagination: tableState.pagination,
    });

    return (
        <TableProvider columns={columns} state={tableState} onStateChange={setTableState}>
            <TableHeader
                title={lt('CashierShiftsPast')}
                subTitle={data?.totalRowCount || 0}
                rightSide={filterComponent}
            />
            <div>
                <Table
                    data-test-id="past-shifts-table"
                    loading={isLoading}
                    uniqueRowId="shiftId"
                    data={data?.data || []}
                    amountOfRows={data?.totalRowCount || 0}
                />
            </div>
        </TableProvider>
    );
};
